import React from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";

export const table2Data = [];
export const table2ColDefs = [];

export const LedgerAccountPopUp = (props) => {
    return (
        <ModalBasic
            id="receive-receipt-details"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}>
            <div className="input-fields bg-white p-[30px] shadow-normalShadow rounded-[10px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Receipt details</span>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-[12px] mb-[10px] pb-2.5 border-b border-slate-200">
                        <div className="input-grp">
                            <label>Ledger no</label>
                            <TextInput type="number" id="ledgerNo" name="ledgerNo" value={props.ledgerDetails.ledgerNo} handleChange={(event) => props.handleChange(event, "ledgerNo")} disabled />
                        </div>
                        <div className="input-grp">
                            <label>Date</label>
                            <TextInput type="date" id="date" name="date" value={props.ledgerDetails.date} handleChange={(event) => props.handleChange(event, "date")} className={props.validState?.error?.date !== undefined ? "error" : ""} />
                        </div>
                        <div className="input-grp">
                            <label>Authorize by</label>
                            <TextInput
                                id="authorizeBy"
                                name="authorizeBy"
                                value={props.ledgerDetails.employeeName}
                                handleOnClick={(event) => props.handleOnClick(event, "authorizeBy")}

                            />
                            {/* <SingleSelectWithSearch id="authorizeBy" name="authorizeBy" value={props.ledgerDetails.authorizeBy} handleChangeTest={(event) => props.handleSelectChange(event, "authorizeBy")} className={props.validState?.error?.authorizeBy !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Expense by</label>
                            <SingleSelectWithSearch
                                drpIdentity={"ExpenseBy"}
                                optionArray={props.expenseBy}
                                value={props.ledgerDetails.expenseById}
                                handleChangeTest={props.handleChange}
                                searchText={props.ledgerDetails.expenseByName}
                                setFilterParameters={props.setFilterParametersTest}
                                classParams={props.validState?.error?.expenseById !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch id="authorizeBy" name="authorizeBy" value={props.ledgerDetails.authorizeBy} handleChangeTest={(event) => props.handleSelectChange(event, "authorizeBy")} className={props.validState?.error?.authorizeBy !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp col-span-2">
                            <label>Select Account</label>
                            <SingleSelectWithSearch
                                drpIdentity={"selectBank"}
                                optionArray={props.bankList}
                                value={props.ledgerDetails.idBank}
                                handleChangeTest={props.handleSelectChange}
                                searchText={props.ledgerDetails.bankName}
                                setFilterParameters={props.setFilterParametersTest}
                                classParams={props.validState?.error?.idBank !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch id="selectAccount" name="selectAccount" value={props.ledgerDetails.selectAccount} handleChangeTest={(event) => props.handleChange(event, "selectAccount")} className={props.validState?.error?.selectAccount !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Cheque series</label>
                            <TextInput
                                id="selectSeries"
                                name="selectSeries"
                                value={props.ledgerDetails.chequeBookSeries}
                                handleOnClick={(event) => props.handleOnClick(event, "selectSeries")}
                                disabled={props.ledgerDetails.expenseById > 0 && props.ledgerDetails.expenseById === 3 ? false : true}
                            />
                            {/* <SingleSelectWithSearch id="chequeSeries" name="chequeSeries" value={props.ledgerDetails.chequeSeries} handleChangeTest={(event) => props.handleSelectChange(event, "chequeSeries")} className={props.validState?.error?.chequeSeries !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Cheque no</label>
                            <SingleSelectWithSearch
                                //id="chequeNo"
                                name="chequeNo"
                                drpIdentity={"chequeNo"}
                                optionArray={props.chequeBookNoList}
                                value={props.ledgerDetails.idChequeBookDetails}
                                handleChangeTest={(event) => props.handleSelectChange(event, "chequeNo")}
                                setFilterParameters={props.setFilterParametersTest}
                                searchText={props.ledgerDetails.chequeNo}
                                disabled={props.ledgerDetails.expenseById > 0 && props.ledgerDetails.expenseById === 3 ? false : true}
                            />
                            {/* <SingleSelectWithSearch id="chequeNo" name="chequeNo" value={props.ledgerDetails.chequeNo} handleChangeTest={(event) => props.handleSelectChange(event, "chequeNo")} className={props.validState?.error?.chequeNo !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp col-span-0.5">
                            <label>Type</label>
                            <SingleSelectWithSearch
                                //id="type"
                                //name="type"
                                //value={props.types} 
                                drpIdentity={"Types"}
                                optionArray={props.types}
                                handleChangeTest={props.handleSelectChange}
                                value={props.ledgerDetails.typeId}
                                setFilterParameters={props.setFilterParametersTest}
                                searchText={props.ledgerDetails.typeName}
                                classParams={props.validState?.error?.typeId !== undefined ? "error" : ""}
                            //disabled={props.ledgerDetails.expenseById > 0 && props.ledgerDetails.expenseById === 1 ? false : true}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Total amount</label>
                            <TextInput
                                type="number"
                                id="enterAmount"
                                name="enterAmount"
                                value={props.ledgerDetails.enterAmount}
                                handleChange={(event) => props.handleChange(event, "enterAmount")}
                                // className={props.validState?.error?.enterAmount !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className="input-grp col-span-2">
                            <label>Remarks</label>
                            <TextInput type="text" id="remarks" name="remarks" value={props.ledgerDetails.remarks} handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div>
                    <div className="ledger-table h-[40vh] pb-[40px]">
                        <div className="table-inner h-full">
                            <h1 className="text-blue text-[16px] font-semibold py-[8px] px-[9px] pt-[0] flex justify-between items-end">Bank ledger account <button className="update-btn btns" onClick={() => props.showNewItemBox()} >Add</button></h1>
                            <AgGridReact
                                rowData={props.addIeamRowData}
                                columnDefs={props.addIeamColDefs}
                                onCellClicked={props.handleCellClick}
                            />
                        </div>
                    </div>
                    <div className="btn-grp inline-flex gap-2.5 mt-[15px]">
                        <button className="update-btn btns"
                            onClick={() => props.submit()}
                            disabled={props.isSaving}
                        >
                            {props.ledgerDetails.updateStatus === 1 ? "Update" : "Save"}</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
}